import { Component } from '@angular/core';
import { BaseFormInput } from '../base-form-input';
import { FormField } from '@nuso/forms/data-access';


@Component({
    selector: 'nuso-date-range-input',
    templateUrl: './date-range-input.component.html',
    styleUrls: ['./date-range-input.component.scss'],
    standalone: false
})
export class DateRangeInputComponent extends BaseFormInput {}
